import type { JSX, ReactNode } from 'react';
import { Button } from './ui';

// =============================================================================
// 위험 구역 — 되돌릴 수 없는 동작은 수정 화면 맨 아래에 (2026-09-18 대교)
//
// 목록의 행 옆에 '삭제'가 있으면 무엇을 지우는지 보지 않고 누르게 되고, 그 자리가 그룹 안의
// 표라서 "이 그룹에서 빼기"로 읽힌다. 실제로는 조직에서 지우거나 기기를 없애는 동작이라
// 자리와 뜻이 어긋난다. 수정 화면 끝으로 옮기고, 무엇이 사라지는지 한 줄로 적는다.
//
// '이 그룹에서만 빼는' 길은 같은 화면 위쪽에 이미 있다(관리자=담당 그룹 체크, 기기=그룹 선택).
// 그래서 여기서는 그 길을 안내만 하고 버튼을 또 두지 않는다 — 비슷한 버튼 둘이 더 헷갈린다.
// =============================================================================

export function DangerZone({ title, description, hint, actionLabel, onAction, disabled, disabledReason }: {
  title: string;
  /** 무엇이 사라지는지 — 범위를 분명히 적는다("조직 전체에서", "기기 등록이 풀리고"). */
  description: string;
  /** 덜 위험한 대안으로 가는 길. 없으면 생략. */
  hint?: ReactNode;
  actionLabel: string;
  onAction: () => void;
  disabled?: boolean;
  disabledReason?: string;
}): JSX.Element {
  return (
    <section aria-label={title} className="mt-6 rounded-md border border-red/40 bg-red/5 px-3 py-3">
      <h3 className="text-[13px] font-semibold text-red">{title}</h3>
      <p className="mt-1 whitespace-pre-line text-[13px] text-text-dim">{description}</p>
      {hint && <p className="mt-1 text-[12px] text-text-dim">{hint}</p>}
      <Button
        className="mt-2.5 border-red/50 text-red hover:border-red hover:bg-red/10"
        disabled={disabled}
        {...(disabled && disabledReason ? { title: disabledReason } : {})}
        onClick={onAction}
      >
        {actionLabel}
      </Button>
    </section>
  );
}
